export default {
    "cookieConsent": "f5fe88a2d78d2213c99032715bf88ffee2024cef2e7fa944ab551a616fa2b451"
};
